<template>
  <div class="set" style="background-color: #f5f5f8">
    <van-nav-bar
      :title="$t('m.fw_span0')"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div style="padding: 10px">
      <img
        src="../../assets/images/new/qiehuan.png"
        style="width: 100%; border-radius: 6px"
        alt=""
      />
      <div style="padding: 10px; border-radius: 6px; background: #fff">
        <div
          style="
            line-height: 40px;
            border-bottom: 1px solid #eee;
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
          @click="qiehuan(index)"
          v-for="(item, index) in dList"
          :key="index"
        >
          <img
            style="width: 20px; height: 20px"
            src="../../assets/images/new/fuwuqi.png"
            alt=""
          />
          <span style="flex: 1; margin-left: 5px">{{ item.name }}</span>
          <img
            :src="select == index ? img1 : img2"
            style="width: 20px; height: 20px"
            alt=""
          />
          <!-- <img v-show="item.select!=index" src="../../assets/images/huibao.png" style="width: 20px;height: 20px;" alt=""> -->
        </div>
        <!-- <div class="register_submit" @click="registerReset">{{$t('m.tijiao')}}</div> -->
      </div>
    </div>
    <div style="height: 100px"></div>
  </div>
</template>

<script>
import $store from "../../store";
import request from "@utils/request";

export default {
  //   name: "",
  data() {
    return {
      img1: require("../../assets/images/new/xuanzhong.png"),
      img2: require("../../assets/images/new/weixuanzhong.png"),
      select: 0,
      dList: []
    };
  },
  computed: {
    list: function () {
      return [
        {
          name: this.$t("m.fw_span0") + "1---pptsdb.com",
          path: "pptsdb.com",
          select: false,
        },
        {
          name: this.$t("m.fw_span0") + "2---cdhaoku.com",
          path: "cdhaoku.com",
          select: false,
        },
        {
          name: this.$t("m.fw_span0") + "3---kiloways.com",
          path: "kiloways.com",
          select: false,
        },
        {
          name: this.$t("m.fw_span0") + "4---edunfg.com",
          path: "edunfg.com",
          select: false,
        },
        {
          name: this.$t("m.fw_span0") + "5---shuyiwhzt.com",
          path: "shuyiwhzt.com",
          select: false,
        },
        {
          name: this.$t("m.fw_span0") + "6---honordeccentcoin.com",
          path: "honordeccentcoin.net",
          select: false,
        },
        {
          name: this.$t("m.fw_span0") + "7---mingzhi-zhang.com",
          path: "mingzhi-zhang.com",
          select: false,
        },
        // {
        //   name: this.$t('m.fw_span0') + "8---yiduapi",
        //   path: "yiduapi.net",
        //   select: false
        // },
        //  {
        //   name: this.$t('m.fw_span0') + "9---induscnapi",
        //   path: "induscnapi.com",
        //   select: false
        // },
        //  {
        //   name: this.$t('m.fw_span0') + "10---zzmdrsqwx",
        //   path: "zzmdrsqwx.com",
        //   select: false
        // }
      ];
    },
  },
  created() {
    request
      .get(
        // "https://octooss-1316590700.cos.ap-shanghai.myqcloud.com/fuwuqi.json"
        "https://octooss.oss-cn-shenzhen.aliyuncs.com/fuwuqi.json"
      )
      .then((res) => {
        this.dList = res.data.list
      });
    for (let index = 0; index < this.list.length; index++) {
      const url = this.list[index].path;
      if ($store.state.app.fwq == url) {
        this.select = index;
      }
    }
  },
  methods: {
    registerReset() {},
    qiehuan(e) {
      this.select = e;
      this.$store.commit("SETFWQ", this.list[this.select].path);
      this.$dialog.success("切换成功！");
      this.$router.push({ path: "/" });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
  components: {},
};
</script>
<style scoped lang="less">
.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 40px;
  background: #CDA569;
  border-radius: 5px;
  margin-top: 20px !important;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  font-size: 16px;
}
.teamindeximg {
  width: 100%;
}

.teamtitle {
  background-color: #f6f6fe;
  font-size: 15px;
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  align-items: center;
  width: calc(100% - 12px);
}

.teamnum {
  background-color: #067594;
  color: #fff;
  padding: 0 8px;
  border-radius: 20px;
  margin-left: 3px;
  font-size: 13px;
  height: 18px;
  line-height: 20px;
}

.teamli {
  border-bottom: 1px solid #f6f6f6;
  padding: 7px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  font-size: 15px;
}

.teamlist {
  padding-right: 12px;
}

.teamlil {
  display: flex;
  align-items: center;
}

.teamlil img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 100%;
  margin-right: 20px;
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
}

/deep/ #all {
  width: 780px;
  padding: 100px 32px;
  background: #fff;
}
</style>
